export default __webpack_public_path__ + "media/images/forbidden-2550x1700-bb48110f7e69c674a43b68b5ea478faf.jpg";